import PropTypes from 'prop-types';
import React from 'react';
import style from './DropdownTick.module.css';

export const DropdownTick = ({ size, fillColor, clickHandler, margin }) => {
  return (
    <svg
      className={style.svg}
      style={{ margin }}
      width={size}
      height={size}
      fill={fillColor}
      onClick={clickHandler}
    >
      <polygon points={`0,0 ${size},0 ${size / 2},${size}`} />
    </svg>
  );
};

DropdownTick.propTypes = {
  clickHandler: PropTypes.any,
  fillColor: PropTypes.any,
  margin: PropTypes.any,
  size: PropTypes.number,
};
